/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useMemo } from 'react';
import getMeta from '@jira/platform__utils-get-meta/src/utils/get-meta/index.tsx';

export const useCustomLogo = (): string | null =>
	useMemo(() => getMeta('ajs-lf-top-adg3-logourl'), []);

export const useCustomIcon = (): string | null => useMemo(() => getMeta('ajs-fspage-favicon'), []);
